import { render, staticRenderFns } from "./SchoolContract.vue?vue&type=template&id=ff60b188&"
import script from "./SchoolContract.vue?vue&type=script&lang=js&"
export * from "./SchoolContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports